module.exports = __webpack_public_path__ + "static/flags/HA-04f424eef949bbbcadfab5f7364211b9.gif";